import { type ComponentProps, memo } from 'react'

import View from './Footer.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function FooterController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Footer_Controller'

export default Controller
